// A member's notification levels, as the api reads and writes them
// (utils/memberNotifications.js on the api side). Display order of the table.
export const NOTIFICATION_TYPES = [
  'invoices',
  'reminders',
  'contracts',
  'timesheets',
  'missions',
];

export const NOTIFICATION_LEVELS = ['none', 'perimeter', 'all'];

// Invoices and reminders concern the whole company, never one perimeter.
const COMPANY_WIDE_TYPES = ['invoices', 'reminders'];

export const allowsPerimeterLevel = (type) =>
  !COMPANY_WIDE_TYPES.includes(type);

const ADMINISTRATOR_ROLE = 225;

// Twin of defaultNotificationsForRole in the api's utils/memberNotifications.js:
// the levels of a member who chose nothing. The api applies them on read and
// never writes them, so an invitation only sends what differs from them.
export const defaultNotificationsForRole = (role) =>
  NOTIFICATION_TYPES.reduce(
    (defaults, type) => ({
      ...defaults,
      [type]:
        Number(role) === ADMINISTRATOR_ROLE || type === 'missions'
          ? 'all'
          : 'none',
    }),
    {},
  );

// The five levels, or null when the answer is not usable: a partial read would
// make the save compare against levels the member does not have.
export const readNotificationLevels = (levels) => {
  if (!levels || typeof levels !== 'object') return null;
  const isComplete = NOTIFICATION_TYPES.every((type) =>
    NOTIFICATION_LEVELS.includes(levels[type]),
  );
  if (!isComplete) return null;
  return NOTIFICATION_TYPES.reduce(
    (read, type) => ({ ...read, [type]: levels[type] }),
    {},
  );
};

// What the api reads for a Director or an Administrator, who cannot hold a
// 'perimeter' level: 'all'. A member without a perimeter keeps it (card 1306).
export const withPerimeterFallback = (levels) =>
  NOTIFICATION_TYPES.reduce(
    (read, type) => ({
      ...read,
      [type]: levels[type] === 'perimeter' ? 'all' : levels[type],
    }),
    {},
  );

// One box per column: checking it gives its level, unchecking it gives none,
// so the two boxes of a row can never be checked together.
export const toggleNotificationLevel = (current, column) =>
  current === column ? 'none' : column;

// The patch the api expects: only the subjects whose level moved.
export const diffNotificationLevels = (before, after) =>
  NOTIFICATION_TYPES.reduce(
    (patch, type) =>
      before[type] === after[type] ? patch : { ...patch, [type]: after[type] },
    {},
  );
